import React from 'react';
import {Helmet} from 'react-helmet-async';
import '../less/index.less';
import additional_product_img_1 from '../img/additional_product_img_1.png';
import additional_product_img_2 from '../img/additional_product_img_2.png';
import hero_img from '../img/hero_img.png';
import FilesForDownloadNew from "../../../auxiliary-components/shared/FilesForDownloadNew";
import TextAboveFooterNew from "../../../auxiliary-components/shared/TextAboveFooterNew";
import CalculatorNew from '../../../auxiliary-components/CalculatorNew';
import QuestionsAdminNew from '../../../auxiliary-components/shared/QuestionsAdminNew';
import Hero from '../../../auxiliary-components/shared/HeroBlock';
import AdditionalProduct from '../../../auxiliary-components/shared/AdditionalProductBlock';
import AdvantagesAdmin from '../../../auxiliary-components/shared/AdvantagesBlockAdmin';
import Tariffs from '../../../auxiliary-components/shared/TariffsBlock';
import { greenCardTerms } from '../../../services/urls/urls';
import FAQStorybook from '@abank/abank-faq';
import Tabs from '../../../auxiliary-components/shared/Tabs';
import CardOrderModal from '../../../auxiliary-components/CardOrderModal';
import { canUseDOM } from '../../../helpers/canUseDOM';
import { Preloader } from 'MWComponents';
import { filterByEnvironment } from '../../../helpers/utils/environmentFilter';
import { howToGetCardItems } from '../../Cards/enums/howToGetCardData';
import HowToBlockNew from '../../../auxiliary-components/shared/HowToBlockNew';

export default function template() {
  const model = this.getModel();

  const page = 'green-card-new';

  const tabs = [{tab: 'tariffs', title: 'GREEN_CARD_NEW_TABS_TITLE_01'},
          {tab: 'calculator', title: 'GREEN_CARD_NEW_TABS_TITLE_02'},
          {tab: 'how-to-get-card', title: 'CARDS_COMMON_NEW_HOW_TO_GET_CARD_TAB_TITLE'}];

  const additionalCards = [
    {
      img: additional_product_img_1,
      link: '/cards/bolt',
      title: 'GREEN_CARD_NEW_CARDS_ADDITIONAL_PRODUCT_TITLE_01',
      text: 'GREEN_CARD_NEW_CARDS_ADDITIONAL_PRODUCT_TEXT_01',
      textBtn: 'GREEN_CARD_NEW_CARDS_ADDITIONAL_PRODUCT_LINK_01',
    },
    {
      img: additional_product_img_2,
      link: '/cards/atb',
      title: 'GREEN_CARD_NEW_CARDS_ADDITIONAL_PRODUCT_TITLE_02',
      text: 'GREEN_CARD_NEW_CARDS_ADDITIONAL_PRODUCT_TEXT_02',
      textBtn: 'GREEN_CARD_NEW_CARDS_ADDITIONAL_PRODUCT_LINK_02',
    }
  ];

  const hero_data = {
    title: 'GREEN_CARD_NEW_HERO_TITLE',
    text: 'GREEN_CARD_NEW_HERO_TEXT',
    link: {
      text: "GREEN_CARD_NEW_HERO_BTN",
      onClick: () => this.toggleModal(),
    },
    cards: [
      {
        title: 'GREEN_CARD_NEW_CARDS_HERO_TITLE_01',
        text: 'GREEN_CARD_NEW_CARDS_HERO_TEXT_01',
      },
      {
        title: 'GREEN_CARD_NEW_CARDS_HERO_TITLE_02',
        text: 'GREEN_CARD_NEW_CARDS_HERO_TEXT_02',
      },
      {
        title: 'GREEN_CARD_NEW_CARDS_HERO_TITLE_03',
        text: 'GREEN_CARD_NEW_CARDS_HERO_TEXT_03',
      }
    ]
  }

  const tariffsData = [
    {
      label: 'GREEN_CARD_NEW_CARDS_TARIFFS_CELL_1_1',
      value: 'GREEN_CARD_NEW_CARDS_TARIFFS_CELL_1_2',
    },
    {
      label: "GREEN_CARD_NEW_CARDS_TARIFFS_CELL_2_1",
      value: "GREEN_CARD_NEW_CARDS_TARIFFS_CELL_2_2",
    },
    {
      label: "GREEN_CARD_NEW_CARDS_TARIFFS_CELL_3_1",
      value: "GREEN_CARD_NEW_CARDS_TARIFFS_CELL_3_2",
    },
    {
      label: {
        html: "GREEN_CARD_NEW_CARDS_TARIFFS_CELL_4_1",
        link: {
          text: "GREEN_CARD_NEW_CARDS_TARIFFS_CELL_4_2",
          onClick: this.scrollToFrequentlyAskedQuestions,
        },
      },
      value: "GREEN_CARD_NEW_CARDS_TARIFFS_CELL_4_3",
    },
    {
      label: "GREEN_CARD_NEW_CARDS_TARIFFS_CELL_5_1",
      value: "GREEN_CARD_NEW_CARDS_TARIFFS_CELL_5_2",
    },
    {
      label: "GREEN_CARD_NEW_CARDS_TARIFFS_CELL_6_1",
      value: "GREEN_CARD_NEW_CARDS_TARIFFS_CELL_6_2",
    },
    {
      label: "GREEN_CARD_NEW_CARDS_TARIFFS_CELL_7_1",
      value: "GREEN_CARD_NEW_CARDS_TARIFFS_CELL_7_2",
    },
    {
      label: "GREEN_CARD_NEW_CARDS_TARIFFS_CELL_8_1",
      value: "GREEN_CARD_NEW_CARDS_TARIFFS_CELL_8_2",
    },
  ];

  const questionsWidget = this.widgetsHelper.getWidget.call(this, 'questions');

  return (
    <div className="module-green-new">
      <Hero
        data={hero_data}
        img={hero_img}
        page={page}
      />
      <div className="content">
        {!this.state.faqTab ? (
          <>
            <AdvantagesAdmin
              data={this.widgetsHelper.getWidget.call(this, 'green_text_block')}
              loader={this.state.loader}
            />
            <Tabs tabs={tabs} toggle={this.toggleTab} tab={this.state.tab} page={page}>
              <Tariffs
                items={tariffsData}
                title={'GREEN_CARD_NEW_CARDS_TARIFFS_TITLE'}
                btnLink={greenCardTerms}
                btnText={'GREEN_CARD_NEW_CARDS_TARIFFS_BTN'}
                page={page}
              />
              {model.creditSum ? (
                <CalculatorNew model={model} type="credit_cards" {...this.props}/>
              ) : (canUseDOM ? <Preloader /> : null)}
              <HowToBlockNew
                title={'CARDS_COMMON_NEW_HOW_TO_GET_CARD_TITLE'}
                items={howToGetCardItems}
              />
            </Tabs>
            <AdditionalProduct
              items={additionalCards}
              title={'GREEN_CARD_NEW_ADDITIONAL_PRODUCT_TITLE'}
              page={page}
            />
            <QuestionsAdminNew
              widget={questionsWidget}
              toggleFaqTab={this.toggleFaqTab}
              title={'FAQ_SHORT_NEW_TITLE'}
            />
            <FilesForDownloadNew
              lang={this.props.lang}
              widget={this.widgetsHelper.getWidget.call(this, 'files_to_download')}
            />
            <TextAboveFooterNew
              widget={this.widgetsHelper.getWidget.call(this, 'text_above_footer')}
            />
          </>
        ) : (
          <FAQStorybook
            widget={questionsWidget}
            title={this.l10n('GREEN_CARD_NEW_FAQ_STORYBOOK_TITLE')}
            btnText={this.l10n('GREEN_CARD_NEW_FAQ_STORYBOOK_BTN_TEXT')}
            onBtnClick={this.toggleFaqTab}
            filterByEnvironment={filterByEnvironment}
          />
        )}
      </div>
      {this.state.showModal ?
        <CardOrderModal closeModal={this.toggleModal} product={'green'} isOpen={this.state.showModal}/> : ''
      }
    </div>
  )
}
